<template>
  <ChecklistTableTaskCellWrapper clickable 
                                 data-locator="comments-area"
                                 @click="openSidePaneOnCommentTab"
  >
    <template v-if="item.lastComment">
      <AppTooltip>
        <template #activator="{ props }">
          <div
            class="comment-wrapper"
            v-bind="props"
          >
            <div class="left-border"/>
            <div class="comment-text text-grey-800">{{ commentText }}</div>
            <div class="text-truncated text-grey-500">{{ authorAndDate }}</div>
          </div>
        </template>
        <div style="max-width: 320px">
          <div class="text--bold">{{ commentText }}</div>
          <div>{{ authorAndDate }}</div>
        </div>
      </AppTooltip>
    </template>
    <template v-else>
      <ChecklistTableTaskEmptyCell />
    </template>
  </ChecklistTableTaskCellWrapper>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import { ISOToShortDate } from '@/common/utils/dates'
import { escapeHtml } from '@/common/utils/strings'
import ChecklistTableTaskCellWrapper from '@/project/checklist/table/ChecklistTableTaskCellWrapper.vue'
import ChecklistTableTaskEmptyCell from '@/project/checklist/table/ChecklistTableTaskEmptyCell.vue'
import { ChecklistSection, ChecklistTask } from '@/project/checklist/types'
import { OPEN_CHECKLIST_PANE } from '@/store/modules/checklist/action_types'


const props = defineProps<{
  item: ChecklistTask;
  parent: ChecklistSection;
}>()

const commentText = computed(() => {
  if (!props.item.lastComment) {
    return ''
  }

  return escapeHtml(props.item.lastComment.message)
})
const authorAndDate = computed(() => {
  if (!props.item.lastComment) {
    return ''
  }

  const { user, createdAt } = props.item.lastComment
  const formattedDate = ISOToShortDate(createdAt, { withArticle: true })

  return `${user.fullName}, ${formattedDate}`
})

const store = useStore()
const openSidePaneOnCommentTab = () => {
  store.dispatch(`checklist/${OPEN_CHECKLIST_PANE}`, {
    isOpen: true,
    parent: props.parent,
    tab: 'comments',
    tasks: [props.item],
  })
}
</script>

<style scoped lang="scss">
.comment-wrapper {
  display: grid;
  grid-template-columns: auto 1fr;
  column-gap: 8px;
}

.left-border {
  border-left: 3px rgb(var(--v-theme-grey-100)) solid;
  border-radius: 3px;
  grid-row: span 2;
}

.comment-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>
